import React from 'react';

import { Route, Switch } from 'react-router-dom';
// Direct page-folder imports — see the code-splitting note in AppRouter.
import { Login } from 'pages/Login';
import { ForgotPassword } from 'pages/ForgotPassword';
import { PATHS } from './config';

export const AuthRouter = () => (
  <Switch>
    <Route exact path={PATHS.login}>
      <Login />
    </Route>
    <Route exact path={PATHS.forgot_password}>
      <ForgotPassword />
    </Route>
  </Switch>
);
